import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";

import { Card, Col, Row, Form, Button } from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import api from "../../../api";
import DatePickerComponent from "../../../components/DatePickerComponent";
import {
  hideLoadingDialog,
  showFailedDialog,
  showLoadingDialog,
} from "../../../helpers/dialog.helper";
import BASE_URL from "../../../api";
import moment from "moment";

const ReportPermohonanPage = () => {
  const [dataLayanan, setDataLayanan] = useState([]);
  const [status, setStatus] = useState([]);
  const [dataFakultas, setDataFakultas] = useState([]);
  const [dataProdi, setDataProdi] = useState([]);

  const [dataForm, setDataForm] = useState({
    startDate: new Date().setDate(1),
    endDate: new Date(),
    idLayanan: "",
    layanan: "",
    idStatus: "",
    idUser: "",
    namaUser: "",
    idFakultas: "",
    namaFakultas: "",
    idProdi: "",
    namaProdi: "",
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getAllResource = async () => {
      try {
        const layananResponse = await axios.get(`${api}/master/layanan`, {
          headers: {
            Authorization: token,
          },
          cancelToken: source.token,
        });

        const fakultasResponse = await axios.get(`${api}/master/fakultas`, {
          cancelToken: source.token,
        });
        
        const statusResponse = await axios.get(`${api}/master/status_transaksi`, {
          headers: {
            Authorization: token,
          },
          cancelToken: source.token,
        });

        const layananFormated = layananResponse.data.data.map((layanan) => ({
          value: layanan.id,
          label: layanan.nama,
        }));
        const fakultasFormated = fakultasResponse.data.data.map((fakultas) => ({
          value: fakultas.id,
          label: fakultas.nama,
        }));
        const statusFormated = statusResponse.data.data.map((status) => ({
          value: status.id,
          label: status.nama,
        }));
        setDataLayanan(layananFormated);
        setDataFakultas(fakultasFormated);
        setStatus(statusFormated);
      } catch (error) {}
    };

    getAllResource();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, []);

  useEffect(() => {
    // Jika newUser.id_fakultas tidak kosong, ambil data prodi
    if (dataForm.idFakultas) {
      axios
        .get(`${api}/master/prodi/get_by_fakultas_id/${dataForm.idFakultas}`)
        .then((prodiResponse) => {
          const prodiFormated = prodiResponse.data.data.map((prodi) => ({
            value: prodi.id,
            label: prodi.nama,
          }));

          setDataProdi(prodiFormated);
        });
    } else {
      // Jika newUser.id_fakultas kosong, set dataProdi menjadi array kosong
      setDataProdi([]);
    }
  }, [dataForm.idFakultas]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoadingDialog();
    try {
      const body = Object.assign(
        {
          ...dataForm,
        },
        {
          startDate: moment(dataForm.startDate).format("YYYY-MM-DD"),
          endDate: moment(dataForm.endDate).format("YYYY-MM-DD"),
        }
      );
      const response = await axios.post(`${BASE_URL}permohonan/report/filepdf`, body, {
        headers: {
          Authorization: token,
        },
        responseType: "arraybuffer",
      });
      hideLoadingDialog();
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a data URL from the blob
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open a new tab with the PDF content
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Something went wrong!",
      });
    }
  };

  return (
    <AdminLayout>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Header title="Report Permohonan Surat" />
        </div>
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={12} className="mb-3">
                <Row>
                  <Col md={6}>
                    <Form.Group id="startDate">
                      <Form.Label>Start Date</Form.Label>
                      <DatePickerComponent
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        selectsStart={true}
                        value={dataForm.startDate}
                        maxDate={dataForm.endDate}
                        onChange={(update) => {
                          setDataForm({ ...dataForm, startDate: update });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group id="endDate">
                      <Form.Label>End Date</Form.Label>
                      <DatePickerComponent
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        selectsEnd={true}
                        minDate={dataForm.startDate}
                        value={dataForm.endDate}
                        onChange={(update) => {
                          setDataForm({ ...dataForm, endDate: update });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="layanan">
                  <Form.Label>Layanan</Form.Label>
                  <Select
                    options={dataLayanan}
                    placeholder="Pilih layanan"
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        idLayanan: e?.value,
                        layanan: e?.label,
                      });
                    }}
                    isClearable={true}
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="idStatus">
                  <Form.Label>Status</Form.Label>
                  <Select
                    options={status}
                    placeholder="Pilih status"
                    isClearable={true}
                    onChange={(e) =>
                      setDataForm({ ...dataForm, idStatus: e?.value })
                    }
                  />
                </Form.Group>
              </Col>
              {/* <Col md={12} className="mb-3">
                <Form.Group id="user">
                  <Form.Label>User</Form.Label>
                  <Select />
                </Form.Group>
              </Col> */}
              <Col md={12} className="mb-3">
                <Form.Group id="fakultas">
                  <Form.Label>Fakultas</Form.Label>
                  <Select
                    options={dataFakultas}
                    placeholder="Pilih fakultas"
                    onChange={(e) =>
                      setDataForm({
                        ...dataForm,
                        idFakultas: e?.value,
                        namaFakultas: e?.label,
                        idProdi: null,
                        namaProdi: null,
                      })
                    }
                    isClearable={true}
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="prodi">
                  <Form.Label>Prodi</Form.Label>
                  <Select
                    options={dataProdi}
                    placeholder="Pilih prodi"
                    isDisabled={!dataForm.idFakultas}
                    value={
                      dataProdi.find((e) => e.value === dataForm.idProdi) ||
                      null
                    }
                    isClearable={true}
                    onChange={(e) =>
                      setDataForm({
                        ...dataForm,
                        idProdi: e?.value,
                        namaProdi: e?.label,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="groupBy">
                  <Form.Label>Group By</Form.Label>
                  <Select
                    options={[
                      {
                        value: ['nama_layanan', 'nim'],
                        label: "Layanan - NIM",
                      },
                      {
                        value: ['nama_layanan', 'str_status'],
                        label: "Layanan - Status",
                      },
                    ]}
                    placeholder="Pilih group by"
                    isClearable={true}
                    onChange={(e) =>
                      setDataForm({ ...dataForm, groupBy: e?.value })
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Button type="submit">Submit</Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </AdminLayout>
  );
};

export default ReportPermohonanPage;
